import React, { PropsWithChildren } from 'react';
import { Layout } from '@duxton-web/ui';
import { useLocation } from 'react-router-dom';

import '@/features/layout/index.css';

import { isMoveITTenant } from '@/common/Tenants';
import MainMenu from '@/features/layout/main-menu';

interface AppLayoutProps {
  onLogout: () => void;
  domainFamily: string;
}

const AppLayout = ({
  onLogout,
  domainFamily,
  children,
}: AppLayoutProps & PropsWithChildren) => {
  const location = useLocation();
  const { pathname } = location;

  // Extract the menu from the URL path
  const pathSegments = pathname.split('/');
  const menuIndex = pathSegments.indexOf(domainFamily) + 1;
  const selectedKey = pathSegments[menuIndex] || 'experiments';

  // Move class name computation inside component
  const layoutClassName = isMoveITTenant()
    ? 'main-layout main-layout-moveit'
    : 'main-layout';

  return (
    <Layout
      className={layoutClassName}
      style={{
        overflow: 'hidden',
      }}
    >
      <MainMenu
        onLogout={onLogout}
        selectedKey={selectedKey}
        domainFamily={domainFamily}
      />
      <Layout.Content
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          maxHeight: '100vh',
          minHeight: '100vh',
          overflowX: 'hidden',
          overflowY: 'hidden',
        }}
      >
        <div
          style={{
            flexGrow: '1',
            overflow: 'hidden',
          }}
        >
          {children}
        </div>
      </Layout.Content>
    </Layout>
  );
};

export default AppLayout;
